// Minimal WebAudio sound effects with a persisted on/off toggle. No assets to
// load; tones are synthesized. Respects the user's preference across sessions.

const STORAGE_KEY = "bibleracers:sound";

let enabled = readPref();
let ctx: AudioContext | null = null;

function readPref(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) !== "off";
  } catch {
    return true;
  }
}

export function isSoundEnabled(): boolean {
  return enabled;
}

export function setSoundEnabled(value: boolean): void {
  enabled = value;
  try {
    localStorage.setItem(STORAGE_KEY, value ? "on" : "off");
  } catch {
    /* ignore */
  }
}

function getCtx(): AudioContext | null {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const Ctor =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext })
        .webkitAudioContext;
    if (!Ctor) return null;
    ctx = new Ctor();
  }
  return ctx;
}

function tone(freq: number, durationMs: number, type: OscillatorType = "sine") {
  if (!enabled) return;
  const audio = getCtx();
  if (!audio) return;
  if (audio.state === "suspended") void audio.resume();

  const osc = audio.createOscillator();
  const gain = audio.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  const now = audio.currentTime;
  gain.gain.setValueAtTime(0.0001, now);
  gain.gain.exponentialRampToValueAtTime(0.18, now + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, now + durationMs / 1000);
  osc.connect(gain).connect(audio.destination);
  osc.start(now);
  osc.stop(now + durationMs / 1000 + 0.02);
}

export const sfx = {
  correct() {
    tone(660, 110, "triangle");
    window.setTimeout(() => tone(990, 130, "triangle"), 90);
  },
  wrong() {
    tone(180, 200, "sawtooth");
  },
  tick() {
    tone(440, 70, "sine");
  },
  go() {
    tone(880, 200, "triangle");
  },
  finish() {
    tone(660, 120, "triangle");
    window.setTimeout(() => tone(880, 120, "triangle"), 120);
    window.setTimeout(() => tone(1180, 200, "triangle"), 240);
  },
};
